import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { TButtonTheme } from '@cian/ui-kit/button/types/TButtonTheme';
import { Button } from '@cian/ui-kit';

import { getIsAuthenticated } from '../../selectors/user';
import { TThunkDispatch } from '../../types/redux';
import { trackNewReviewButton } from './tracking';
import { getObjectId } from '../../selectors/objectInfo';
import { requestAuthentication } from '../../actions/authentication';
import { getNewReviewLoading } from '../../selectors/newReview/getNewReviewLoading';
import { fetchFormDataAndOpenModalAction } from '../../actions/newReview/fetchFormDataAndOpenModalAction';

export interface INewReviewButtonProps {
  size?: 'XS' | 'M' | 'L';
  fill?: TButtonTheme;
  fullWidth?: boolean;
}

export function NewReviewButtonContainer({
  size = 'M',
  fill = 'fill_primary',
  fullWidth = true,
}: INewReviewButtonProps) {
  const dispatch = useDispatch<TThunkDispatch>();
  const isAuthenticated = useSelector(getIsAuthenticated);
  const objectId = useSelector(getObjectId);
  const isLoading = useSelector(getNewReviewLoading);

  const handleOpenReviewForm = React.useCallback(async () => {
    trackNewReviewButton({ objectId });

    if (isAuthenticated) {
      dispatch(fetchFormDataAndOpenModalAction());
    } else {
      dispatch(requestAuthentication({ onSuccess: fetchFormDataAndOpenModalAction }));
    }
  }, [dispatch, isAuthenticated, objectId]);

  return (
    <Button
      data-testid="NewReviewButton"
      size={size}
      fullWidth={fullWidth}
      theme={fill}
      onClick={handleOpenReviewForm}
      loading={isLoading}
    >
      Написать отзыв
    </Button>
  );
}
